import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=c8a095d0"
import script from "./GiftDetail.vue?vue&type=script&lang=js"
export * from "./GiftDetail.vue?vue&type=script&lang=js"
import style0 from "./GiftDetail.vue?vue&type=style&index=0&id=c8a095d0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports